import { useState } from "react";
import _ from "lodash";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import LabelInput from "../Commons/LabelInput";
import { dataValidator } from "../../tools/dataValidator";

import { getLabel } from "../../tools/Dictionary";

const ProcessDesignerSchemaModal = (props) =>
{

  //Props
  const Access = props.Access;
  const Template = props.Template;
  const Step = props.Step;
  const Parent = props.Parent;
  const OnConfirm = props.onConfirm;
  const CheckTitleExists = props.checkTitleExists;
  const OnCloseModal = props.OnCloseModal;

  //State
  const [form, setForm] = useState({
    title: ""
  });
  const [error, setError] = useState({

  });
  const [loading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useMount(() => {

    loadData();

  });

  const loadData = () => {



    let tempForm = {
      title: Step.title
    };


    if (Template.prefill.yesno){
      tempForm.yesno_name = Step.component[0].name;
      tempForm.yesno_label = {
        "EN": "Edit your text",
        "FR": "",
        "ES": ""
      };

    }


    setForm(tempForm);

  };

  const onChangeValue = (e, _property, _length = undefined) => {

    let value = e.target.value;

    if (_length && value && value.length > _length) return;
    
    onValidateField(_property, value);

    let tempForm = _.cloneDeep(form);

    tempForm[_property] = value;

    setForm(tempForm);

  };

  const onChangeTitle = (e) => {

    let title = e.target.value;

    if (title && title.length > 60) return;

    onValidateField("title", title);

    setForm(form => ({
      ...form,
      title
    }))

  };

  const onChangeInput = (_value, _field) =>
  {

    let tempForm = _.cloneDeep(form);

    tempForm[_field] = _value;

    setForm(tempForm);

  };




  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "title";
    if ((field == "" || field == currentField) && Template.prefill.title)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:60"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "yesno_name";
    if ((field == "" || field == currentField) && Template.prefill.yesno)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:50"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };


  const onClickConfirm = () => {

    try
    {

      if (!onValidateField()) throw new Error(getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."));

      if (Template.prefill.title){
        if (CheckTitleExists(form.title)) throw new Error(getLabel("ProcessDesignerSchemaModal", "The specified step title already exists. Please choose a unique title for this step."));
      }

      let toAddStep = _.cloneDeep(Step);

      if (Template.prefill.title)
        toAddStep.title = form.title;

      if (Template.prefill.yesno){
        toAddStep.component[0].name = form.yesno_name;
        toAddStep.component[0].data.text = form.yesno_label;
      }


      OnConfirm(toAddStep, Parent);

      OnCloseModal();


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  }
 
  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {Template.title}
        </div>
        <div className="page_modal_body_cont">
          {Template.prefill.title &&
            <div className="page_modal_body_row">
              <div className="page_modal_body_col_title">
                {getLabel("ProcessDesignerSchemaModal", "Title")}
              </div>
              <div className="page_modal_body_col_value" style={{ width: "400px" }} >
                <input
                  className={"page_text_input " + (error["code"] ? "page_modal_body_col_input_error" : "")}
                  value={form.title || ""}
                  onChange={onChangeTitle}
                  type="text"
                  style={{ width: "100%" }}
                  disabled={!Access.canWrite || loading}
                  autoFocus={true}
                />
                {error["title"] &&
                  <div className="page_modal_body_col_extra page_modal_body_col_error">
                    {error["title"]}
                  </div>
                }
              </div>
            </div>
          }
          {Template.prefill.yesno &&
            <div className="page_modal_body_row">
              <div className="page_modal_body_col_title">
                {getLabel("ProcessDesignerSchemaModal", "Yes/No ID")}
              </div>
              <div className="page_modal_body_col_value" style={{ width: "400px" }} >
                <input
                  className={"page_text_input " + (error["code"] ? "page_modal_body_col_input_error" : "")}
                  value={form.yesno_name || ""}
                  onChange={(e) => onChangeValue(e, "yesno_name", 50)}
                  type="text"
                  style={{ width: "100%" }}
                  disabled={!Access.canWrite || loading}
                />
                {error["yesno_name"] &&
                  <div className="page_modal_body_col_extra page_modal_body_col_error">
                    {error["yesno_name"]}
                  </div>
                }
              </div>
            </div>
          }
          {Template.prefill.yesno && 
            <div className="page_modal_body_row">
              <div className="page_modal_body_col_title">
                {getLabel("ProcessDesignerSchemaModal", "Yes/No Question Text")}
              </div>
              <div className="page_modal_body_col_value" style={{ width: "600px" }} >
                <LabelInput
                  ReadOnly={!Access.canWrite}
                  Data={form.yesno_label}
                  ListValidation={["max:1000"]}
                  TextStyle={{ height: "100px" }}
                  PreviewMaxLength={400}
                  Property={"yesno_label"}
                  OnChangeValue={onChangeInput}
                />
                {error["yesno_label"] &&
                  <div className="page_modal_body_col_extra page_modal_body_col_error">
                    {error["yesno_label"]}
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Return")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Confirm")}
            style={{ maxWidth: "200px" }}
            onClick={(loading && !onClickConfirm) ? undefined : onClickConfirm}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default ProcessDesignerSchemaModal